import { ArtistType } from '@api';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

const contactPersonSchema = z
  .object({
    personId: z.string(),
    companyId: z.string(),
  })
  .nullable();

const formSchema = z.object({
  agent: contactPersonSchema,
  buyer: contactPersonSchema,
  manager: contactPersonSchema,
  productManager: contactPersonSchema,
  projectLead: contactPersonSchema,
  coordinator: contactPersonSchema,
});

export type ArtistContactsFormSchemaType = z.infer<typeof formSchema>;

type UseArtistContactsFormReturnType =
  UseFormReturn<ArtistContactsFormSchemaType>;

export const useArtistContactsForm = (
  artist: ArtistType
): UseArtistContactsFormReturnType => {
  return useForm({
    defaultValues: {
      agent: artist.agent,
      buyer: artist.buyer,
      manager: artist.manager,
      productManager: artist.productManager,
      projectLead: artist.projectLead,
      coordinator: artist.coordinator,
    },
    resolver: zodResolver(formSchema),
  });
};
